import { render } from "./newsDetail1.vue?vue&type=template&id=12b1e417"
import script from "./newsDetail1.vue?vue&type=script&lang=js"
export * from "./newsDetail1.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zytdwl\\zytdwl_cms\\zytdwl_cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__